var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.visible)?_c('div',{class:['poprun-message', _vm.type],on:{"click":_vm.closeMessage}},[_c('img',{attrs:{"src":require("../../assets/images/closeIcon.png"),"width":"32","height":"32","alt":""}}),_c('div',{staticClass:"pop_message"},[_vm._v(" "+_vm._s(_vm.message)+" ")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }